"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.replaceNewLinesWithPilcrowSign = exports.ValueOrEmptyStringComponent = void 0;
const ProjectConfigStoreDataProvider_1 = require("src/configeek_assets/src/components/common/provider/ProjectConfigStoreDataProvider");
const lodash_1 = __importDefault(require("lodash"));
const React = __importStar(require("react"));
const EmptyValueComponent_1 = require("src/configeek_assets/src/components/loggedIn/common/EmptyValueComponent");
const ValueOrEmptyStringComponent = (props) => {
    let value = typeof props.value === "string" ? { type: "string", value: props.value } : props.value;
    let valueString = ((0, ProjectConfigStoreDataProvider_1.getConfigurationValueText)(value) || "");
    if (props.showViewLines === true) {
        valueString = (0, exports.replaceNewLinesWithPilcrowSign)(valueString);
        // if (process.env.NODE_ENV === "development") {
        //     valueString += "{\n" +"aaaaaaa".repeat(100)+
        //         "    \"canisters\": {\n" +
        //         "        \"example_canisterId\": {},\n" +
        //         "        \"xzcnc-myaaa-aaaak-abk7a-cai\": {\n" +
        //         "            \"tokenId\": {\n" +
        //         "                \"start\": 0,\n" +
        //         "                \"shift\": 0\n" +
        //         "            }\n" +
        //         "        },\n" +
        //         "    }\n" +
        //         "}".repeat(5)
        // }
    }
    if (lodash_1.default.isEmpty(valueString)) {
        return React.createElement(EmptyValueComponent_1.EmptyValueComponent, null);
    }
    return React.createElement(React.Fragment, null, valueString);
};
exports.ValueOrEmptyStringComponent = ValueOrEmptyStringComponent;
const PILCROW_SIGN = "\u00b6";
const replaceNewLinesWithPilcrowSign = (value, leaveNewLines) => lodash_1.default.replace(value || "", /\n/g, leaveNewLines === true ? `${PILCROW_SIGN}\n` : PILCROW_SIGN);
exports.replaceNewLinesWithPilcrowSign = replaceNewLinesWithPilcrowSign;
